export enum DestinationType {
    FTP = 'FTP',
    GoogleDrive = 'Google Drive',
    GoogleSheets = 'Google Sheets',
    S3 = 'S3 Bucket',
    Snowflake = 'Snowflake'
}